import { createContext } from 'react';

export const ThemeContext = createContext<{
    layoutId: string;
    variation?: number;
}>({
    layoutId: '',
});
